import useMediaQuery from '@/hooks/use-media-query'
import { UserType } from '@/types/UserType'
import { logout } from '@/utils/Functions'
import { LogOutIcon } from 'lucide-react'
import React from 'react'
import { Image } from 'react-bootstrap'
import { NavLink, useNavigate } from 'react-router-dom'

const MD_BREAKPOINT = '(min-width: 769px)'

function SidebarApp() {
  const isDesktop = useMediaQuery(MD_BREAKPOINT)
  const navigate = useNavigate()

  // État pour stocker les données de l'utilisateur
    const [userData, setUserData] = React.useState<UserType>()
  
React.useEffect(() => {
      const storedUserData = localStorage.getItem(import.meta.env.VITE_APP_SESSION_USER)
      if (storedUserData) {
        const parsedUserData = JSON.parse(storedUserData)
        setUserData(parsedUserData)
      }
    }, [])

  const handleLogout = () => {
      logout()
      navigate('/connexion')
    }
  return (
    <>
      {isDesktop && (
        <ul
          className='navbar-nav bg--primary sidebar sidebar-dark accordion'
          id='accordionSidebar'
        >
          <NavLink
            className='sidebar-brand d-flex align-items-center justify-content-center'
            to='/'
          >
            <div className='sidebar-brand-icon'>
              <Image src='/img/logo.png' width={50} className='img-fluid' alt='Logo' />
            </div>
            <div className='sidebar-brand-text mx-3'>Dashboard</div>
          </NavLink>

          <hr className='sidebar-divider my-0' />
          <li className='nav-item'>
            <NavLink className='nav-link' to='/societes'>
              <i className='ri-building-line'></i>
              <span>Sociétés</span>
            </NavLink>
          </li>
          <li className='nav-item'>
            <NavLink className='nav-link' to='/lockers'>
              <i className='ri-home-wifi-line'></i>
              <span>Machines</span>
            </NavLink>
          </li>
          <li className='nav-item'>
            <NavLink className='nav-link' to='/bookings'>
              <i className='ri-calendar-check-fill'></i>
              <span>Bookings</span>
            </NavLink>
          </li>
          <li className='nav-item'>
            <NavLink className='nav-link' to='/livraisons'>
              <i className='ri-truck-line'></i>
              <span>Livraisons</span>
            </NavLink>
          </li>
          <li className='nav-item'>
            <NavLink className='nav-link' to='/utilisateurs'>
              <i className='ri-group-line'></i>
              <span>Utilisateurs</span>
            </NavLink>
          </li>
          {/* <li className='nav-item'>
        <a href={import.meta.env.VITE_APP_END_POINT} target='_blank' className='nav-link'>
        <i className='ri-code-line'></i>
        <span>Documentation API</span>
        </a>
        </li> */}

          {/* <div className='text-center d-none d-md-inline mt-5'>
        <button className='rounded-circle border-0' id='sidebarToggle'>
        <i className='ri-arrow-left-s-line'></i>
        </button>
        </div> */}
      <div className='d-flex flex-column nav-item mt-auto' >
        <hr className='sidebar-divider border-white mt-auto' />
                <div className='d-flex align-items-center gap-2 nav-link py-0'>
                  <Image
                    src={'/img/avatar-default.png'}
                    alt='Image'
                    width={30}
                  />
                  <div>{userData?.firstName}</div>
                </div>
                <div className='d-flex align-items-center gap-2 mt-2 nav-link py-1' onClick={handleLogout}>
                  <LogOutIcon size={25} />
                  Déconnectez vous
                </div>
              </div>
        </ul>
      )}
    </>
  )
}

export default SidebarApp
